import theme from '../../../../../lib/theme';
const {
	layouts,
	colors,
	scale,
	media,
	mediaSizes,
	font: { families, heights, spacings, ...font },
} = theme;
export default () => ({
	homepageLayout: {
		display: 'flex',
		width: '100%',
		maxWidth: mediaSizes.xxl,

		[`@media (max-width: ${mediaSizes.xxl}px)`]: {
			padding: `0 0.5em!important`,
		}
	},
	layoutColumns: {
		'> div': {
			width: `100%`,
			maxWidth: `100%`,

			[media.xl.down]: {
				// width: `100%!important`,
				// maxWidth: `100%!important`,
			}
		},

		[media.xl.down]: {
			flexDirection: 'column',
		}
	},
	ad: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',

		'&:before': {
			content: '"-Advertisement-"',
			display: 'block',
			fontSize: '0.7em',
			color: 'rgba(102, 102, 102, 0.7)',
			textAlign: 'center',
		},
	}

});